
const MouseIcon = ({className}) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className}><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 3V9M12 3C15.3137 3 18 5.68629 18 9M12 3C8.68629 3 6 5.68629 6 9M6 9H18M6 9V15C6 18.3137 8.68629 21 12 21C15.3137 21 18 18.3137 18 15V9" stroke="#731cd0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ></path> </g></svg>
  )
}

export default MouseIcon